import AWS from 'aws-sdk'

const S3FileStore = {
  namespaced: true,
  state: {
    currentUploadStats: {
      speedClockTime: null,
      uploadedBytes: 0,
      speed: 0,
      progress: 0
    }
  },
  mutations: {
    setCurrentUploadStats: (state, payload) => {
      state.currentUploadStats.speed = payload.speed
      state.currentUploadStats.progress = payload.progress
      state.speedClockTime = payload.speedClockTime
      state.uploadedBytes = payload.uploadedBytes
    },
    resetCurrentUploadStats: (state) => {
      state.speedClockTime = null
      state.uploadedBytes = 0
      state.currentUploadStats.speed = 0
      state.currentUploadStats.progress = 0
    },
    startUpload: (state) => {
      state.uploadedBytes = 0
      state.speedClockTime = new Date().getTime()
    }
  },
  actions: {
    /**
     * Uploads a file to S3 and indicates progress via state: currentUploadStats
     * @param {Object} payload
     *   RequiredKeys: file: FileObject - Browse FileObject to upload
     *                 bucket: Bucket to upload to
     *                 key: Full file path and name e.g foo/bar/somefile.txt
     *                 credentials: AWS Credentials Objects (should come from cognito)
     *
     */
    upload ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('resetCurrentUploadStats')
        const s3Service = new AWS.S3({
          credentials: payload.credentials,
          signatureVersion: 'v4',
          apiVersion: '2006-03-01',
          region: process.env.VUE_APP_COGNITO_REGION
        })
        const s3Upload = new AWS.S3.ManagedUpload({
          service: s3Service,
          params: {
            Bucket: payload.bucket,
            Key: payload.key,
            Body: payload.file
          }
        })
        commit('startUpload')
        s3Upload.on('httpUploadProgress', function (progressEvent) {
          const currentTime = new Date().getTime()
          const timeElapsedInSeconds = (currentTime - state.currentUploadStats.speedClockTime) / 1000
          if (timeElapsedInSeconds > 0) {
            const speed = (progressEvent.loaded - state.currentUploadStats.uploadedBytes) / timeElapsedInSeconds
            const progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
            commit('setCurrentUploadStats', {
              speed: speed,
              progress: progress,
              speedClockTime: currentTime,
              uploadedBytes: progressEvent.loaded
            })
          }
        })
        s3Upload.send((err, data) => {
          if (err) {
            reject(err)
          } else {
            resolve(data)
          }
        })
      })
    }
  }
}

export default S3FileStore
